import AppInnerFooter from "Layout/AppInnerFooter";
import React, { useState } from "react";
import {
	Button
} from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import { ReactComponent as Arrow } from "../../../../../../assets/utils/images/svgs/Arrow 3.svg";
import { useControlshermContext } from "../context/ControlshermContext";
import { useNavigate } from "react-router";
import { BsCheckCircle } from "react-icons/bs";

export default function Footer() {
	const navigate = useNavigate();
	 const [modalOpen, setModalOpen] = useState(false); 
     const [buttonClicked, setButtonClicked] = useState(null); 


	const { setIsOpen, dayId, subsId, isButtonsEnabled, handleAssignment,isButtonDisabled } = useControlshermContext();

	const handleNavigationBack = () => {
		navigate(`/verzoeken/planscreen/${subsId}/${dayId}`);
	};
	

	const handleButtons = (status) => {
		if (!isButtonsEnabled) {
			setButtonClicked(status);
			setModalOpen(true); 
		} else {
			handleAssignment(status); 
		}
	};

	const toggleModal = () => setModalOpen(!modalOpen);

	return (
		<AppInnerFooter
			footerWrapperClassName="chat-layout-footer planscreen__footer mb-6"
			cardFooterClassName="chat-layout-footer__inner gebruikers-footer flex-wrap flex-xxl-nowrap gap-2 justify-content-center justify-content-xxl-between chat-layout-footer__inner"
		>
			<div className="flex-xxl-grow-1 flex-wrap flex-xxl-nowrap d-flex justify-content-center justify-content-xxl-between gap-2 footer--coordinator-planboard__checkbox-container">
				<div className="d-flex align-items-stretch gap-2">
					<Button
						size="sm"
						outline
						className="btn-color-style footer-btn-styling"
						color="primary"
						onClick={() => setIsOpen((prev) => !prev)}
					>
						Contactregistratie
					</Button>
				</div>

				<div className="d-flex justify-content-center align-items-center gap-2">
					<Button
						size="sm"
						outline
						className="btn-color-style footer-btn-styling"
						color="primary"
						onClick={() => handleButtons("Voorlopig")}
						  disabled={isButtonDisabled}

					>
						Voorlopig
					</Button>
					<Button
						size="sm"
						outline
						className="btn-color-style footer-btn-styling "
						color="primary"
						onClick={() => handleButtons("Aangevraagd")}
						  disabled={isButtonDisabled}

					>
						<BsCheckCircle color='#39A825' className="me-2 fs-5 " />
						Aanvragen
					</Button>
					<Button
						size="sm"
						outline
						className="btn-color-style footer-btn-styling"
						color="primary"
						onClick={() => handleButtons("Ingepland")}
                          disabled={isButtonDisabled}
					>
						Inplannen
					</Button>
					<Button
						size="sm"
						outline
						className="btn-color-style footer-btn-styling"
						color="primary"
						onClick={handleNavigationBack}
					>
						<Arrow />
					</Button>
				</div>
			</div>
				<Modal isOpen={modalOpen} toggle={toggleModal} className="modal-centered contract-type-modal feedback-modal-style link-form">
				<ModalHeader toggle={toggleModal} className='px-3 mt-4'>Waarschuwing</ModalHeader>
				<ModalBody className='text-center mt-4 mb-4'>
					<p className="contracttype-Modal">
						U wilt de controlemeldingen negeren. Weet u dit zeker ?
					</p>
				</ModalBody>
				<ModalFooter className='justify-content-center pt-3'>
					<Button color="link" className={"btn-color-style"} onClick={toggleModal}>
						Annuleren
					</Button>
					<Button color="link"  className={"btn-color-style"} onClick={() => {
						handleAssignment(buttonClicked);
						toggleModal(); 
					}}>
						Akkoord
					</Button>
				</ModalFooter>
			</Modal>
		</AppInnerFooter>
	);
}
